import { GET_ACCOUNT_MESSAGE } from './action';

const initState = {
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case GET_ACCOUNT_MESSAGE: 
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/AccountQuestion/state/reducer.js